export const TextCounter = ({
  limit,
  current,
}: {
  limit: number;
  current: number | null;
}) => {
  if (current === null) return <></>;
  return (
    <div className="tw-rounded-b-lg tw-bg-primary tw-px-3 tw-py-1 tw-font-sans tw-text-[11px] tw-font-semibold tw-leading-tight tw-text-white">
      {current}/{limit}
    </div>
  );
};
